import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Honour any `next` deep link stashed before OAuth bounce
        let next = "/dashboard";
        try {
          const stashed = sessionStorage.getItem("login_next");
          if (stashed) { next = stashed; sessionStorage.removeItem("login_next"); }
        } catch {}
        window.history.replaceState({}, "", next);
        navigate(next, { replace: true, state: { user: res.data } });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        navigate("/login", { replace: true, state: { authError: typeof detail === "string" ? detail : null } });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-xs uppercase tracking-[0.2em] text-zinc-500" data-testid="auth-callback-loading">
        Establishing session…
      </div>
    </div>
  );
}
